import { render, staticRenderFns } from "./MEM002M08.vue?vue&type=template&id=0d2a2f8e&"
import script from "./MEM002M08.vue?vue&type=script&lang=js&"
export * from "./MEM002M08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports